import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
var Container = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  border-radius: 2em;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 1;\n  min-width: 1px;\n  padding: 0.16666666666667em 0.5em;\n  text-align: center;\n"])), function (props) {
  return "\n    background-color: ".concat(props.backgroundColor, ";\n    color: ").concat(props.textColor, ";\n  ");
});
export default Container;